// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3WWnp","button":"styles__button___qrrQW","approved":"styles__approved___RCQvi","rejected":"styles__rejected___oqJFO"};